// You can use this as a template for building new controller Classes.
// Create an instance of your Class in the main index.js file


export default class HorizontalSlider {
  //===========================================================================
  // Constructor
  //===========================================================================

  constructor(init) {
    if (init) {
      this.state = {
        $sliders: $('.js-horizontal-slider')
      };

      this.updateSlidersOnLoad();
      this.setupEventListeners();
      this.reset();
    }
  }

  //===========================================================================
  // Moves the slider
  //===========================================================================

  moveSlider(e) {
    const $target = $(e.currentTarget);
    const $slider = $target.closest('.js-horizontal-slider-wrapper').find('.js-horizontal-slider');

    if ($target.hasClass('prev')) {
      this.moveSliderLeft($slider);
    } else {
      this.moveSliderRight($slider);
    }
  }

  //===========================================================================
  // Moves the slider left
  //===========================================================================

  moveSliderLeft($slider) {
    const sliderPos = $slider.scrollLeft();
    const cardWidth = $slider.find('.js-horizontal-slide').outerWidth(true);
    let newPos      = (cardWidth) * (Math.round(sliderPos/cardWidth) - 1);

    if (newPos < 0) { newPos = 0; }

    $slider.animate({ scrollLeft: newPos }, "fast");
  }

  //===========================================================================
  // Moves the slider right
  //===========================================================================

  moveSliderRight($slider) {
    const sliderPos = $slider.scrollLeft();
    const cardWidth = $slider.find('.js-horizontal-slide').outerWidth(true);
    const newPos    = (cardWidth) * (Math.round(sliderPos/cardWidth) + 1);

    $slider.animate({ scrollLeft: newPos }, "fast");
  }

  //===========================================================================
  // Filters a pdp slider gallery if it exists
  //===========================================================================

  filterSliderGallery(e) {
    const $target = $(e.currentTarget);
    const $slider = $target.closest('.js-pdp-wrapper').find('.js-horizontal-slider-wrapper').not('.hidden');
    const $slides = $slider.find('.js-horizontal-slide');
    const $arrows = $slider.find('.js-pdp-slider-arrows');
    const variant = e.variant;
    const product = e.product;

    if ($slides[0] && variant && variant.id) {
      const sliderInner = $slider.find('.js-horizontal-slider')[0];
      const $videos = $('.js-pdp-slider-video');
      let slideCount = 0;

      $slider.addClass('hidden');
      this.updateVideoPlayStatus($videos, false);

      setTimeout(() => {
        $slides.each((i, slide) => {
          const $slide = $(slide);
          const formattedAlt = `/${ ($slide.data('alt') || '').replace(/\s\/\s/g, '/').toLowerCase() }/`;
          const formattedName = `/${ (variant.title || '').replace(/\s\/\s/g, '/').toLowerCase() }/`;
          const slideShowsForAll = $slide.data('alt') == $slide.data('product');
          const slideIsVariantImage = formattedName.includes(formattedAlt);
          const slideIsVariantFeaturedImage = $slide.data(String(variant.id));

          if (slideIsVariantImage || slideIsVariantFeaturedImage || slideShowsForAll) {
            $slide.removeClass('hidden');
            $slide.find('.js-lazy-load-ignore').removeClass('js-lazy-load-ignore')
            this.updateVideoPlayStatus($slide.find('.js-pdp-slider-video'), true);
            slideCount += 1;
          } else {
            $slide.addClass('hidden');
          }
        });

        if (slideCount > 1) {
          $arrows.removeClass('hidden');
        } else {
          $arrows.addClass('hidden');
        }

        if (sliderInner) { sliderInner.scrollTo(0, 0); }
        $slider.removeClass('hidden');
        $(document).trigger('revealImages');
      }, 500);
    }
  }

  //===========================================================================
  // Plays or pauses videos on load / change
  //===========================================================================

  updateVideoPlayStatus($videos, playVideo) {
    $videos.each((i, video) => {
      if (playVideo) {
        if (!$(video).hasClass('js-no-play')) {
          video.play();
        }
      } else {
        video.pause();
      }
    });
  }

  //===========================================================================
  // Triggers some slider updates on page load
  //===========================================================================

  updateSlidersOnLoad() {
    const $sliders = $('.js-horizontal-slider');

    $sliders.each((i, slider) => {
      this.updateDynamicSliderButton(slider);
    });
  }

  //===========================================================================
  // Triggers some slider updates on scroll
  //===========================================================================

  updateSliderOnScroll(e) {
    const slider = e.currentTarget;
    this.updateDynamicSliderButton(slider);
  }

  //===========================================================================
  // Shows/Hides certain buttons on scroll
  //===========================================================================

  updateDynamicSliderButton(slider) {
    const $dynamic = $(slider).closest('.js-horizontal-slider-wrapper').find('.js-horizontal-slider-dynamic');
    const scrollPosition = slider.scrollLeft;
    const scrollEnd = slider.scrollWidth - slider.offsetWidth;
    let position;

    if (scrollPosition < 10) {
      position = 'start';
    } else if (scrollEnd - scrollPosition < 10) {
      position = 'end';
    }

    $dynamic.each((i, el) => {
      const $el = $(el);

      if (position === 'start' && $el.hasClass('prev')) {
        $el.addClass('invisible');
      } else if (position === 'end' && $el.hasClass('next')) {
        $el.addClass('invisible');
      } else {
        $el.removeClass('invisible');
      }
    });
  }

  //===========================================================================
  // Reset
  //===========================================================================

  reset() {
    if (this.state.$sliders) {
      this.state.$sliders.off('scroll', this.updateSliderOnScroll.bind(this));
    }

    this.state.$sliders = $('.js-horizontal-slider');
    this.state.$sliders.on('scroll', this.updateSliderOnScroll.bind(this));

    this.state.$sliders.each((i, slider) => {
      this.updateDynamicSliderButton(slider);
    });
  }

  //===========================================================================
  // Sets up event listeners
  //===========================================================================

  setupEventListeners() {
    $(document).on('click', '.js-horizontal-slider-arrow', this.moveSlider.bind(this));
    $(document).on('variantChange', '.js-product-wrapper', this.filterSliderGallery.bind(this));
    $(document).on('resetSliders', this.reset.bind(this));
    $(document).on('historyChange', this.reset.bind(this));
  }
}
